import { useQuery } from "@tanstack/react-query";

import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getRegistrationRequests,
  type RegistrationRequestListOrderBy,
  type RegistrationRequestStatus,
  type RegistrationRequestType,
  type SortOrder,
} from "RegistrationRequests/Api/registrationRequestApi";
import { REGISTRATION_REQUESTS_QUERY_KEYS } from "./queryKeys";

export interface RegistrationRequestsQueryParams {
  offset?: number;
  limit?: number;
  status?: RegistrationRequestStatus | null;
  type?: RegistrationRequestType | null;
  searchQuery?: string | null;
  orderBy?: RegistrationRequestListOrderBy;
  sortOrder?: SortOrder;
}

export function useRegistrationRequestsQuery(
  params: RegistrationRequestsQueryParams,
) {
  const { offset, limit, status, type, searchQuery, orderBy, sortOrder } =
    params;

  return useQuery({
    queryKey: REGISTRATION_REQUESTS_QUERY_KEYS.list(
      offset,
      limit,
      status,
      type,
      searchQuery,
      orderBy,
      sortOrder,
    ),
    queryFn: processResponse(() =>
      getRegistrationRequests(
        offset,
        limit,
        status,
        type,
        searchQuery,
        orderBy,
        sortOrder,
      ),
    ),
  });
}
